<template>
  <div>
    <div class="download-item">
      <!--左侧内容-->
      <div style="float: left">
        <!--序号-->
        <div style="float: left;text-align: center; width: 20px; line-height: 60px;margin: 0 30px; font-size: 20px">
          {{ num }}
        </div>
        <!--正文-->
        <div style="float: left;">
          <!--标题-->
          <div style="font-size: 20px;  margin-top: 5px;">
            <a @click="handleDownload">{{ downloadItemData.download_title }}</a>
          </div>
          <!--备注-->
          <div style="font-size: 14px; margin-top: 5px">文件大小： {{downloadItemData.download_size}}</div>
        </div>
      </div>
      <!--右侧内容-->
      <div style="float: right; line-height: 60px; margin-right: 30px">
        <el-button type="primary" plain @click="getDownloadLink">
          下载<i class="el-icon-download el-icon--right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDownloadLinkUtil } from '@/utils/index'

export default {
  name: 'DownloadItem',
  props: {
    downloadItemData: {
      type: Object,
      require: true
    },
    num: {
      type: Number,
      require: true
    }
  },
  data () {
    return {}
  },
  methods: {
    handleDownload () {
      this.$router.push(`/download?id=${this.downloadItemData.download_id}`)
    },
    getDownloadLink () {
      getDownloadLinkUtil(this.downloadItemData.download_id)
    }
  }
}
</script>

<style scoped>
  .download-item {
    width: 100%;
    height: 60px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .1);
    transition: box-shadow 0.2s;
  }
  .download-item:hover {
    box-shadow: 0 1px 15px rgba(0, 21, 41, .15);
  }
</style>
